"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
// import { OLAPTransformer } from "./transformer/OLAPTransformer";
// import { OLAPTransformerQuery } from "./transformer/OLAPTransformerQuery";
class Cube {
    constructor(mddeDataService, definition, dictionaries, parameters) {
        this.id = definition.id;
        this.definition = definition;
        this._mddeService = mddeDataService;
        this._attrsDictionaries = dictionaries;
        this._parameters = parameters;
        // build
        this._parameters = parameters;
    }
    query(query) {
        return __awaiter(this, void 0, void 0, function* () {
            // create MDDE query from OLAP query
            // add parameters
            const mddeQuery = Object.assign(Object.assign({}, query), { parameters: this._parameters });
            const data = yield this._mddeService.query(mddeQuery);
            // const transform = (query: OLAPTransformerQuery) => {
            //     const OLAPTransformerInstance = new OLAPTransformer({ data, attrsDictionaries: this._attrsDictionaries });
            //     return OLAPTransformerInstance.getData(query);
            // };
            const result = {
                data,
            };
            return result;
        });
    }
    getAttributeDictionary(path) {
        const dict = this._attrsDictionaries.get(path);
        if (dict === undefined) {
            throw new Error(`path ${path} is not found in cube ${this.id}`);
        }
        return dict;
    }
    static validateParameters(definition, parametersValues, attributesMetadata) {
        const { id, parameters } = definition;
        const parametersMap = new Map(Object.entries(parameters));
        const parametersValuesMap = new Map(Object.entries(parametersValues || []));
        if (parametersValuesMap.size !== parametersMap.size) {
            throw new Error(`Cube ${id} parameters count mistmatch ${parametersValues}`);
        }
        parametersMap.forEach((def) => {
            const parameterId = def.id;
            if (!parametersValuesMap.has(parameterId)) {
                throw new Error(`Parameter ${parameterId} value missed for cube ${id}`);
            }
        });
        attributesMetadata.forEach((attrMeta) => {
            var _a;
            const dictBinding = attrMeta.dictionaryBinding;
            (_a = dictBinding.parametersBinding) === null || _a === void 0 ? void 0 : _a.forEach(({ cubeParameterId }) => {
                if (!parametersValuesMap.has(cubeParameterId)) {
                    throw new Error(`Parameter ${cubeParameterId} value missed for cube ${id} attribute to dictionary ${dictBinding.dictionaryId} binding`);
                }
            });
        });
    }
}
exports.Cube = Cube;
//# sourceMappingURL=Cube.js.map